type Listener = (isDown: boolean) => void;

const CONSECUTIVE_FAILURES_THRESHOLD = 3;
const CONSECUTIVE_SUCCESSES_THRESHOLD = 3;

let consecutiveFailures = 0;
let consecutiveSuccesses = 0;
let isDown = false;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((fn) => fn(isDown));
};

export const serverStatus = {
  get isDown() {
    return isDown;
  },

  recordFailure() {
    consecutiveSuccesses = 0;
    consecutiveFailures += 1;
    if (consecutiveFailures >= CONSECUTIVE_FAILURES_THRESHOLD && !isDown) {
      isDown = true;
      notify();
    }
  },

  recordCriticalFailure() {
    consecutiveSuccesses = 0;
    consecutiveFailures = CONSECUTIVE_FAILURES_THRESHOLD;
    if (!isDown) {
      isDown = true;
      notify();
    }
  },

  recordSuccess() {
    if (isDown) {
      consecutiveSuccesses += 1;
      if (consecutiveSuccesses >= CONSECUTIVE_SUCCESSES_THRESHOLD) {
        consecutiveFailures = 0;
        consecutiveSuccesses = 0;
        isDown = false;
        notify();
      }
    } else {
      consecutiveFailures = 0;
      consecutiveSuccesses = 0;
    }
  },

  subscribe(fn: Listener) {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  },
};
